export default __webpack_public_path__ + "static/media/0028.de785ffa.png";